import React, { useState } from 'react';
import { preFormatFilterObject } from '@nile/reports/src/modules/component/helper';
import { FormattedMessage } from 'react-intl';
import { onQuerySearch } from '@nile/reports/src/modules/EfficiencyReport/graphql/resolver';
import { CurrencyText, Loader, withErrorBoundary } from '@nile/components';
import { cloneDeep, isEmpty } from 'lodash';
import { useQuery } from '@nile/graphql';
import { DisplayText, TextStyle } from '@superops/ui-design-system';

function NumberCard({ advancedChart, condition }) {
  const {
    dataKey,
    labelKey,
    api,
    cellType = 'TEXT',
    listInfo = false
  } = advancedChart;

  const { client, query } = onQuerySearch(api);

  const [data, setData] = useState({});

  const { operands, reportCondition } = preFormatFilterObject({
    entity: 'OfferedItem',
    filterObj: cloneDeep(condition),
    removeLabel: true
  });

  const ipCondition =
    (reportCondition &&
      !isEmpty(operands) && {
        joinOperator: 'AND',
        operands: operands || null
      }) ||
    null;
  const { loading } = useQuery(query, {
    client,
    fetchPolicy: 'cache-and-network',
    variables: {
      input: listInfo
        ? {
            page: 0,
            pageSize: 20,
            condition: ipCondition
          }
        : null
    },
    onCompleted(res) {
      setData(res[api]);
    }
  });

  const getValue = () => {
    switch (cellType) {
      case 'CURRENCY_HOUR':
      case 'CURRENCY':
        return (
          <CurrencyText
            value={data?.[dataKey]}
            perValue={cellType === 'CURRENCY_HOUR'}
            config={{ notation: 'compact' }}
          />
        );
      default:
        return data?.[dataKey];
    }
  };

  return (
    <div className="p15 full-width full-height">
      <div className="flex mb20">
        <TextStyle weight="SemiBold">
          <FormattedMessage id={labelKey} />
        </TextStyle>
      </div>
      <>
        {loading ? (
          <div className="flex-center h91">
            <Loader />
          </div>
        ) : (
          <>
            {(!isEmpty(data) && (
              <DisplayText element="h1" weight="SemiBold">
                {getValue(data?.[dataKey])}
              </DisplayText>
            )) || (
              <TextStyle variation="subdued" weight="SemiBold">
                <FormattedMessage id="app.noData.message" />
              </TextStyle>
            )}
          </>
        )}
      </>
    </div>
  );
}

export default withErrorBoundary(NumberCard);
